import React, { createRef, useEffect, useState } from 'react';
import { Layout } from 'react-feather';
import moment from 'moment';
import DateFormat from 'constants/date_format';
import { routes } from 'constants/config';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import Card from '../ui/Card';
import TemplateCardBack from './TemplateCardBack';
import TemplateCardCoverImage from './TemplateCardCoverImage';

const TemplateCard = ({ template, selectTemplate }) => {
  const [isCardFlipped, setIsCardFlipped] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const cardRef = createRef();

  const previewUrl = routes.PREVIEW_TEMPLATE(template.id);
  const { lastUpdatedAt, createdAt } = template;
  const date = lastUpdatedAt ? lastUpdatedAt.date : createdAt.date;
  const formattedDate = moment(date).format(DateFormat.MONTH_DAY_YEAR_SHORT);

  const renderCoverImage = () =>
    template.coverImage ? (
      <TemplateCardCoverImage {...template.coverImage} />
    ) : (
      <div className="TemplateCard-defaultImage">
        <Layout size="62" />
      </div>
    );

  const handleCardHover = () => {
    setIsCardFlipped(true);
    setIsFocused(true);
  };

  useEffect(() => {
    if (!isFocused && !cardRef.current?.contains(document.activeElement)) {
      setIsCardFlipped(false);
    }
  }, [isFocused, cardRef, setIsCardFlipped]);

  return (
    <div
      role={isCardFlipped ? 'presentation' : 'button'}
      tabIndex={isCardFlipped ? -1 : 0}
      onClick={() => {
        setIsCardFlipped(!isCardFlipped);
        setIsFocused(!isFocused);
      }}
      onBlur={() => setIsFocused(false)}
      onMouseEnter={handleCardHover}
      onKeyDown={handleCardHover}
      onFocus={handleCardHover}
      onMouseLeave={() => {
        setIsCardFlipped(false);
        setIsFocused(false);
      }}
      onMouseDown={e => {
        e.preventDefault();
      }}
      className="Card TemplateCard TemplateCard-hasImage"
    >
      <Card.Content className="TemplateCard-content">
        <Text className="TemplateCard-title" variant={TEXT_VARIANTS.BODY_BOLD}>
          {template.title}
        </Text>

        {isCardFlipped && (
          <TemplateCardBack
            template={template}
            ref={cardRef}
            previewUrl={previewUrl}
            setIsFocused={setIsFocused}
            formattedDate={formattedDate}
            selectTemplate={selectTemplate}
          />
        )}
        {renderCoverImage()}
        <Text
          className="TemplateCard-footer"
          variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
        >
          {t('templates.gallery.last_updated_on', { date: formattedDate })}
        </Text>
      </Card.Content>
    </div>
  );
};

export default TemplateCard;
